var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}]},[_c('vx-card',[(_vm.skillUpdatePermission)?_c('vs-row',[_c('div',{staticClass:"vx-col w-full mb-base"},[_c('div',[_c('SkillsForm',{attrs:{"data":_vm.skillItem,"isEditActive":true}})],1)])]):_c('not-permission')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }